import { createUseStyles } from "react-jss";

export default createUseStyles ( theme => ( {
	bottomStickyBtnContainer: {
		display         : "flex",
		justifyContent  : "space-around",
		alignItems      : "center",
		flexFlow        : "wrap",
		// margin         : "0px auto 10px",
		// top             : "calc(100vh - 64px)",
		bottom          : "-1px",
		zIndex          : "10",
		width           : "100%",
		backgroundColor : theme.colors.dialog.secondary,
		padding         : "10px 13px",
		position        : "fixed",
		border          : theme.darkMode ? "none" : `1px solid ${ theme.colors.border.primary }`
	},
	downloadBtn: {
		flexBasis       : "100%",
		padding         : "8px !important",
		color           : "white !important",
		borderRadius    : "10px",
		fontWeight      : "bold  !important",
		fontSize        : "16px !important",
		textTransform   : "none !important",
		backgroundImage : "linear-gradient(to left, #439aff 11%, #126bd5 92%)"
	},
	mobileSvg: {
		height      : "20px",
		width       : "20px",
		marginRight : "0.5rem"
	}
} ) );
